import { render, staticRenderFns } from "./EmptyRetur.vue?vue&type=template&id=9e8414f0"
import script from "./EmptyRetur.vue?vue&type=script&lang=js"
export * from "./EmptyRetur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports